import Swiper, {Autoplay, Navigation, Pagination, EffectFade} from 'swiper';

window.addEventListener('load', () => {
        let galleryThumbs = new Swiper(".gallery-thumbs", {
            centeredSlides: true,
            slideToClickedSlide: true,
            spaceBetween: 10,
            slidesPerView: 5,

        });
        let galleryTop = new Swiper(".gallery-top", {
            modules: [Navigation],
            direction: "horizontal",
            spaceBetween: 10,
            slidesPerView: '1',
            observeParents: true,
            parallax: true,
            thumbs: {
                swiper: galleryThumbs
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        galleryTop.on('slideChangeTransitionStart', function () {
            galleryThumbs.slideTo(galleryTop.activeIndex);
        });
        galleryThumbs.on('transitionStart', function () {
            galleryTop.slideTo(galleryThumbs.activeIndex);
        });
});
